import storage from './storage'

const PREFIX = 'neat'

const USERNAME = `${PREFIX}::global::userName`
export const LAST_VALIDATION_ID = `${PREFIX}::global::lastValidationId`
export const LAST_VALIDATION_EXPIRES_AT = `${PREFIX}::global::lastValidationExpiresAt`
export const LAST_VALIDATION_EMAIL = `${PREFIX}::global::lastValidationEmail`

/**
 * User Name (Global)
 */
export const getUserName = () => storage.get(USERNAME)
export const setUserName = (name: string) => storage.set(USERNAME, name)
export const clearUserName = () => storage.remove(USERNAME)

/**
 * Last Validation ID (Global)
 */
export const getLastValidationId = () => storage.get(LAST_VALIDATION_ID)
export const setLastValidationId = (validationId: string) => storage.set(LAST_VALIDATION_ID, validationId)
export const clearLastValidationId = () => storage.remove(LAST_VALIDATION_ID)

/**
 * Last Validation Expires At
 */
export const getLastValidationExpiresAt = () => storage.get(LAST_VALIDATION_EXPIRES_AT)
export const setLastValidationExpiresAt = (expiresAt: string) => storage.set(LAST_VALIDATION_EXPIRES_AT, expiresAt)
export const clearLastValidationExpiresAt = () => storage.remove(LAST_VALIDATION_EXPIRES_AT)

/**
 * Last Validation Email (Global)
 */
export const getLastValidationEmail = () => storage.get(LAST_VALIDATION_EMAIL)
export const setLastValidationEmail = (validationEmail: string) => storage.set(LAST_VALIDATION_EMAIL, validationEmail)
export const clearLastValidationEmail = () => storage.remove(LAST_VALIDATION_EMAIL)
